import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box, Card, Chip, IconButton,
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import RoomDimensionsFields from '../RoomDimensionsFields';

const EditRoomDialog = ({
  open, onClose, selectedRoom,
  editedRoomName, onNameChange,
  editedSquareFootage = '', onSquareFootageChange,
  editedCeilingHeight = '', onCeilingHeightChange,
  onSubmit, onOpenItemEdit, isMobile,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={isMobile}>
    <DialogTitle>Edit Room</DialogTitle>
    <DialogContent>
      <TextField
        autoFocus
        margin="dense"
        label="Room Name"
        type="text"
        fullWidth
        variant="outlined"
        value={editedRoomName}
        onChange={(e) => onNameChange(e.target.value)}
        placeholder="e.g., Kitchen, Master Bedroom"
        sx={{ mt: 1, mb: 2 }}
      />

      <RoomDimensionsFields
        sx={{ mb: 3 }}
        squareFootage={editedSquareFootage}
        onSquareFootageChange={onSquareFootageChange}
        ceilingHeight={editedCeilingHeight}
        onCeilingHeightChange={onCeilingHeightChange}
      />

      {selectedRoom && selectedRoom.items && selectedRoom.items.length > 0 && (
        <>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Items in this Room
          </Typography>
          <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
            {selectedRoom.items.map((item) => (
              <Card key={item.id} sx={{ mb: 2, p: 2 }}>
                <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      {item.description}
                    </Typography>
                    <Typography variant="body1" color="primary" fontWeight="bold" sx={{ mt: 1 }}>
                      ${parseFloat(item.cost).toFixed(2)}
                    </Typography>
                    <Chip label={item.type} size="small" sx={{ mt: 1 }} color="primary" variant="outlined" />
                  </Box>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => onOpenItemEdit(item)}
                    aria-label={`Edit item: ${item.title}`}
                  >
                    <EditIcon />
                  </IconButton>
                </Box>
              </Card>
            ))}
          </Box>
        </>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onSubmit} variant="contained" color="primary" disabled={!editedRoomName.trim()}>
        Save Changes
      </Button>
    </DialogActions>
  </Dialog>
);

export default EditRoomDialog;
